<template>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
          <v-card-title class="primary white--text title">
              Model
          </v-card-title>
          <v-card-text>
              <span class="caption">Target Equipment</span>
              <v-text-field label="Facility Name" v-model="activeItem.facility_name" disabled></v-text-field>
              <equipment-selector v-model="activeItem.equipment_name"></equipment-selector>
              <v-divider></v-divider>
              <span class="caption">Model Selection</span>

              <v-select v-model="activeItem.model_type" :items="['anomaly', 'supervised', 'power']" label="Model Type">
              </v-select>

              <v-select v-model="activeItem.model_name" :items="availableModelName" lable="Model Name"></v-select>

              <v-checkbox label="Active" v-model="activeItem.model_active"></v-checkbox>
              <v-text-field label="Topic" v-model="activeItem.topic"></v-text-field>


              <template v-if="activeItem.model_type=='supervised'">
                  <span class="caption">Model Message</span>
                  <code class="pa-4">
                      {{activeItem.result_meta}}
                  </code>
                  <v-text-field label="Title" v-model="activeItem.title"></v-text-field>
                  <v-text-field label="Description" v-model="activeItem.desc"></v-text-field>
                  <v-text-field label="Severity" v-model="activeItem.severity"></v-text-field>
                  <v-text-field label="Relevant Variables" v-model="activeItem.relevant_variables"></v-text-field>
                  <v-text-field label="Recommended Actions" v-model="activeItem.recommended_actions"></v-text-field>
              </template>

              <span class="caption">Training Data Date Range</span>
              <date-range-selector v-model="dateRange"></date-range-selector>

          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord();dialog=false;" :disabled="!$can('update', 'Points')">Save</v-btn>
              <v-btn @click="initializeVar();dialog=false">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import EquipmentSelector from '../EquipmentSelector'
  import {putModel} from '../../helper'
  import DateRangeSelector from '../DateRangeSelector'

  export default {
    components: { DateRangeSelector, EquipmentSelector },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    computed: {
      availableModelName () {
        if (this.activeItem.model_type=='supervised'){
          if (this.$store.getters.chillerType == 'generic water-cooled') {
            return [
              'Reduced Condenser Water Flow',
              'Condenser Fouling',
              'Non-Condensable in Refrigerant',
              'High Oil Temperature'
            ]
          } else if (this.$store.getters.chillerType == 'air-cooled 2 circuits') {
            return [
              'Air Cooled Winding Temp High Ckt2',
              'Air Cooled Winding Temp High Ckt1',
              'Air Cooled Condenser Cleaning Required',
              'Air Cooled Non Condensable in Refrigerant Ckt1',
              'Air Cooled Non Condensable in Refrigerant Ckt2'
            ]
          }
        } else if (this.activeItem.model_type=='anomaly') {
          return ['anomaly']
        } else if (this.activeItem.model_type=='power') {
          return ['regression', 'gradient boosted trees', 'neural network']
        } else {
          return ['please select a model type first']
        }
      }
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
          this.dateRange = {
            start: this.activeItem.model_date_from,
            end: this.activeItem.model_date_to
          }
        }
      },
      value () {
        if (!this.activeItem.model_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dateRange: null,
        dialog: false,
        activeItem: {
            'model_id': null,
            'model_type': '',
            'model_name': '',
            'model_status': 'pending',
            'model_active': false,
            'title': '',
            'topic': 'default',
            'desc': '',
            'severity': '',
            'relevant_variables': '',
            'recommended_actions': '',
            'on': true,
            'equipment_name': '',
            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
            'date_range': null
        } ,

      }

    },
    mounted() {
      this.dialog = false
    },
    methods: {
      initializeVar() {
        this.activeItem = {
          'model_id': null,
            'model_type': '',
            'model_name': '',
            'model_status': 'pending',
            'model_active': false,
            'title': '',
            'desc': '',
            'topic': 'default',
            'severity': '',
            'relevant_variables': '',
            'recommended_actions': '',
            'on': true,
            'equipment_name': '',
            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
            'model_date_from': null,
            'model_date_to': null
          }
      },
      addRecord () {
        putModel(
          {
            'model_id': this.activeItem.model_id,
            'model_type': this.activeItem.model_type,
            'model_name': this.activeItem.model_name,
            'model_status': this.activeItem.model_status,
            'model_active': this.activeItem.model_active,
            'title': this.activeItem.title,
            'topic': this.activeItem.topic,
            'desc': this.activeItem.desc,
            'severity': this.activeItem.severity,
            'relevant_variables': this.activeItem.relevant_variables,
            'recommended_actions': this.activeItem.recommended_actions,
            'on': this.activeItem.on,
            'equipment_name': this.activeItem.equipment_name,
            'facility_name': this.activeItem.facility_name,
            'model_date_from': this.dateRange.start,
            'model_date_to': this.dateRange.end
          }
        )
      }
    },
    name: 'ModelRecordDialog'
  }
</script>

<style scoped>

</style>
